import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import AddMemberLayer from "../../../components/Admin/AddMemberLayer";

const AddMember = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <AddMemberLayer />
      </MasterLayout>
    </>
  );
};
export default AddMember
